(function ($) {
  "use strict";

  $.fn.idle = function (options) {
    var defaults = {
        idle: 60000, //idle time in ms
        events: "mousemove keydown mousedown touchstart", //events that will trigger the idle resetter
        onIdle: function () {}, //callback function to be executed after idle time
        onActive: function () {}, //callback function to be executed after back from idleness
        onHide: function () {}, //callback function to be executed when window is hidden
        onShow: function () {}, //callback function to be executed when window is visible
        keepTracking: true, //set it to false if you want to track only the first time
        startAtIdle: false,
        recurIdleCall: false,
      },
      idle = options.startAtIdle || false,
      visible = !options.startAtIdle || true,
      settings = $.extend({}, defaults, options),
      lastId = null,
      resetTimeout,
      timeout;

    //event to clear all idle events
    $(this).on("idle:stop", {}, function (event) {
      $(this).off(settings.events);
      settings.keepTracking = false;
      resetTimeout(lastId, settings);
    });

    resetTimeout = function (id, settings) {
      if (idle) {
        idle = false;
        settings.onActive.call();
      }
      clearTimeout(id);
      if (settings.keepTracking) {
        return timeout(settings);
      }
    };

    timeout = function (settings) {
      var timer = settings.recurIdleCall ? setInterval : setTimeout,
        id;
      id = timer(function () {
        idle = true;
        settings.onIdle.call();
      }, settings.idle);
      return id;
    };

    return this.each(function () {
      lastId = timeout(settings);
      $(this).on(settings.events, function (e) {
        lastId = resetTimeout(lastId, settings);
      });
      if (settings.onShow || settings.onHide) {
        $(document).on(
          "visibilitychange webkitvisibilitychange mozvisibilitychange msvisibilitychange",
          function () {
            if (
              document.hidden ||
              document.webkitHidden ||
              document.mozHidden ||
              document.msHidden
            ) {
              if (visible) {
                visible = false;
                settings.onHide.call();
              }
            } else {
              if (!visible) {
                visible = true;
                settings.onShow.call();
              }
            }
          }
        );
      }
    });
  };
})(jQuery);

$(function () {
  const idleWindow = {
    init() {
      $(document).idle({
        onIdle: function () {
          idleWindow.stickyNav();
        },
        idle: 5000,
      });
    },
    stickyNav() {
      let st = 0;
      let triggerStart = 0;
      let triggerTransition = 400;

      st = window.scrollY;
      triggerStart = $("header").outerHeight(true) * 2;
      triggerTransition = $("header").outerHeight(true) * 4;

      if (st > triggerStart) {
        document.querySelector("body").classList.add("trigger-sticky");
      } else {
        document.querySelector("body").classList.remove("trigger-sticky");
      }

      if (st > triggerTransition) {
        document.querySelector("body").classList.add("trigger-transition");

        document.querySelector("body").classList.add("scroll-up");
        document.querySelector("body").classList.remove("scroll-down");
      } else {
        document.querySelector("body").classList.remove("trigger-transition");
      }
    },
  };

  idleWindow.init();
});
